module.exports = __webpack_public_path__ + "static/media/pc3.1616f3e6.png";